import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router'
import { api } from '../api/client'
import type { AppDetail } from '../api/types'
import { useAuth } from '../auth/AuthProvider'
import { AboutPanel } from '../components/app/AboutPanel'
import { AppHeader } from '../components/app/AppHeader'
import { CompetitorsPanel } from '../components/app/CompetitorsPanel'
import { RankPanel } from '../components/app/RankPanel'
import { RatingsPanel } from '../components/app/RatingsPanel'
import { ReviewsPanel } from '../components/app/ReviewsPanel'
import { VersionList } from '../components/app/VersionList'

export function AppScreen() {
	const id = Number(useParams().id)
	const { user } = useAuth()
	const app = useQuery({ queryKey: ['app', id], queryFn: () => api.get<AppDetail>(`/api/v1/apps/${id}`) })
	if (app.isPending) return <div className="page-loading">Loading…</div>
	if (app.isError) return <div className="empty">We haven’t seen app {id} in any chart yet.</div>
	return (
		<div className="stack">
			<AppHeader app={app.data} />
			<AboutPanel appId={id} />
			<RankPanel app={app.data} />
			{user?.role === 'admin' && <CompetitorsPanel appId={id} />}
			<div className="grid">
				<RatingsPanel appId={id} />
				<VersionList versions={app.data.versions} />
			</div>
			<ReviewsPanel appId={id} />
		</div>
	)
}
